export class FileUtility {
  public static getFilename(filePath: string): string {
    const fileIndex = filePath.lastIndexOf('/') + 1;
    return filePath?.substring(fileIndex);
  }
}
